<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2021/02/19
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->


<template>
    <div>
        <!-- PLAN LECTOR -->

        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="estadoModal" fullscreen @close-modal="$emit('close')"
                stlye="overflow: hidden !important;">
                <template v-slot:title>
                    {{ formTitle }} -
                    <v-chip label small class="mx-2">
                        {{ datos.titulo }}
                    </v-chip>
                </template>
                <template v-slot:body>
                    <div>
                        <audio v-if="datos.audio" :src="rutaServer + datos.audio" autoplay controls></audio>
                        <span v-else>No cuenta con audio</span>
                    </div>
                    <div>
                        <iframe v-if="datos.archivo" :src="rutaServer + datos.archivo" type="application/pdf" width="100%"
                            height="800px"></iframe>
                        <span v-else>No cuenta con pdf</span>

                    </div>

                </template>
            </ComunDialogComp>
        </v-form>
    </div>
</template>

<script>


import axios, { API_URL } from "@/helpers/axios"
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";


export default {
    name: 'modalIncidenciaFormulario',

    components: {
        ComunDialogComp
    },
    props: {
        parametros: {
            type: Object
        },
        estadoModal: {
            type: Boolean
        },
    },


    data: vm => ({

        datoLogin: sessionStorage,
        evento: null,
        test: false,
        datos: {},
        paramComponente: { 'id_submodulo': 22, "id_modulo": 4 },

        //-- funciones del date picker de fecha
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),

        menu2: false,
        inhabilitarFecha: false,
        inhabilitarHoraInicio: false,
        // Variables para la imagen
        previewImg: '',
        fileImageSave: '',
        rutaServer: API_URL,
        inhabilitarButton: false,


        filter: {},
        listNivel: [],
        listGrado: [],
        listSeccion: [],
        listAlumno: [],

        datosAlumno: {},

        listTipoIncidencia: [],
        listIncidencia: [],
        listUsuarioPerfil: [],
        listUsuario: [],
        listPapeleta: [],


        search: "",
        headers: [
            /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
            { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
            { text: 'SELECCIONAR', value: 'action_select', class: 'secondary black--text' },
            { text: 'CÓDIGO', value: 'id', align: 'left', class: 'secondary black--text' },
            { text: 'DESCRIPCIÓN', value: 'descripcion', class: 'secondary black--text' },
            { text: 'NIVEL', value: 'nivel_incidencia', class: 'secondary black--text' },

        ],


        //validaciones de formulario
        rul: {
            required: value => !!value || 'Campo Requerido',
            inputReq: value => !!value || 'Campo Requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },

            hora: value => {
                if (value < '00:01') {
                    return 'El formato de la hora ingresada es incorrecto'
                }
                else {
                    if (value >= '23:59') {
                        return 'El formato de la hora ingresada es incorrecto'
                    }
                }
            },
        },

    }),

    mounted() {
        this.loadMain()
    },

    //computadas
    computed: {

        ...mapGetters('login', ['componenteEvento']),

        formTitle() {
            //return this.parametros.evento === 'agregar' ? 'AGREGAR REGISTRO DE INCIDENCIA CONDUTUAL' : 'EDITAR REGISTRO DE INCIDENCIA CONDUTUAL'
            return 'PLAN LECTOR'
        },

        computedDateFormatted2() {
            return this.formatDate(this.datos.fecha)
        },


    },


    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoModal() {

            if (this.estadoModal) {
                this.loadMain()
            } else {
                //this.parametros = {}
                this.limpiarForm()

            }
        }
    },


    methods: {

        ...mapActions('login', ['parametroComponente']),

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        // Maxima Fecha Calendario fecha actual
        getEndDate() {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1; // Los meses en JavaScript se indexan desde 0, por lo que se suma 1
            if (month < 10) {
                month = '0' + month; // Agregar un cero al mes si es menor a 10 (para obtener el formato MM)
            }
            const day = today.getDate();

            return `${year}-${month}-${day}`;
        },


        //  ------- input tipo fecha  --------
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },


        loadMain() {
            this.limpiarForm()
            this.datos = this.parametros.item

        },

        // FUNCION PARA VERIFICAR SI UN ARCHIVO EXISTE ANTES DE RENDERIZARLO (COMO EL AUDIO O PDF)
        verificarArchivo(pathArchivo) {
            if (!pathArchivo) return false
            const url = this.rutaServer + pathArchivo;
            axios.get(url)
                .then(() => {
                    return true;
                })
                .catch(() => {
                    return false;
                });
        },


        async editItem(item) {

            this.datos = item
            this.datos.id_usuario = this.datoLogin.id

        },



        resetValidation() {
            this.$refs.formDatos.resetValidation()
        },






        limpiarForm() {
            //    num_documento:77889966, num_documento2:55887745,                
            this.datos = {
                id_us: this.datoLogin.id,
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_periodo: "",
                id_tipo_incidencia: "",
                id_incidencia: "",
                id_papeleta: "",
                id_alumno: "",
                id_perfil: "",
                id_usuario: "",
                registro_tipo: 1,
                ano_lectivo: "",
                periodo: "",
                nivel: "",
                grado: "",
                seccion: "",
                alumno: "",
                num_documento: "",
                fecha: "",
                hora: "",
                nivel_incidencia: "",
                descripcion_incidencia: "",
                puntaje: "",
                observacion: "",
                img_nombre: "",
                img_ruta: ""
            }

            this.datosAlumno = { nivel: '', grado: '', seccion: '' }

            this.previewImg = ''
            this.fileImageSave = ''
            this.resetValidation()

        },


    },
}
</script>
<style scoped></style>